module.exports = __webpack_public_path__ + "static/media/000003.4cbc74e3.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/000003.mp3
// module id = 121
// module chunks = 0